// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__16Olw","clinicsSelect":"TableHeading_clinicsSelect__31r8n"};